import { COMPANY_EMPLOYEE } from "../actions/types";

const initialState = {
  notifyErrorCompanyEmployeeAssignment: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },

  getScheduleOfCompanyEmployee: {
    schedule: [],
    isFetching: false,
    errorMessage: null,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    // #region COMPANY_EMPLOYEE.NOTIFY_ERROR

    case COMPANY_EMPLOYEE.COMPANY_EMPLOYEE_NOTIFY_ERROR_REQUEST:
      return {
        ...state,
        notifyErrorCompanyEmployeeAssignment: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case COMPANY_EMPLOYEE.COMPANY_EMPLOYEE_NOTIFY_ERROR_SUCCESS:
      return {
        ...state,
        notifyErrorCompanyEmployeeAssignment: {
          successMessage: "Melding is succesvol verzonden.",
          errorMessage: null,
          isFetching: false,
        },
      };

    case COMPANY_EMPLOYEE.COMPANY_EMPLOYEE_NOTIFY_ERROR_FAIL:
      return {
        ...state,
        notifyErrorCompanyEmployeeAssignment: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region COMPANY_EMPLOYEE.GET_SCHEDULE

    case COMPANY_EMPLOYEE.COMPANY_EMPLOYEE_GET_SCHEDULE_REQUEST:
      return {
        ...state,
        getScheduleOfCompanyEmployee: {
          schedule: [],
          isFetching: true,
          errorMessage: null,
        },
      };

    case COMPANY_EMPLOYEE.COMPANY_EMPLOYEE_GET_SCHEDULE_SUCCESS:
      return {
        ...state,
        getScheduleOfCompanyEmployee: {
          schedule: action.payload,
          isFetching: false,
          errorMessage: null,
        },
      };

    case COMPANY_EMPLOYEE.COMPANY_EMPLOYEE_GET_SCHEDULE_FAIL:
      return {
        ...state,
        getScheduleOfCompanyEmployee: {
          schedule: [],
          isFetching: false,
          errorMessage: [
            "Er is iets foutgegaan bij het ophalen van de agenda. Probeer het later opnieuw.",
          ],
        },
      };

    // #endregion

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/companyEmployeeReducer.js